import { render, staticRenderFns } from "./FormEliminarAnotaciones.vue?vue&type=template&id=657eb582&"
import script from "./FormEliminarAnotaciones.vue?vue&type=script&lang=js&"
export * from "./FormEliminarAnotaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports